import { useEffect } from 'react';

interface ComingSoonPopupProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

export default function ComingSoonPopup({
  isOpen,
  onClose,
  title = 'Coming soon',
  message = "This feature is in development and will be available soon. Thanks for your patience.",
}: ComingSoonPopupProps) {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="eyebrow" style={{ marginBottom: 8 }}>
          Heads up
        </div>
        <h3 className="display tight" style={{ fontSize: 24, margin: '0 0 10px' }}>
          {title}
        </h3>
        <p className="muted-2" style={{ fontSize: 13.5, lineHeight: 1.55, margin: '0 0 22px' }}>
          {message}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button type="button" className="btn primary" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
